<template>
  <v-container
    class="px-1 py-1"
    fluid
    grid-list-sm>
    <v-toolbar
      color="primary">
      <v-btn
        icon
        class="white--text"
        @click="$router.push('/')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <img src="../../../assets/background.svg"
           class="mt-4 mb-4 "
           height="100%"
           alt="Logo"/>
      <v-toolbar-title
        class="headline px-5 white--text">
        {{ $t(translation + ".header_public") }}
      </v-toolbar-title>

      <v-tooltip top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-4 info"
            dark
            v-bind="attrs"
            v-on="on"
            :disabled="tableDataLoading || tableData.length === 0"
            :loading="reportDownloading"
            @click="refreshData(false, false, reportData)">
            <v-icon class="white--text">mdi-download</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltips.report') }}</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <v-tooltip top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            :loading="tableDataLoading"
            :disabled="tableDataLoading"
            v-bind="attrs"
            v-on="on"
            class="warning"
            @click="refreshData(true, true)">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltips.refresh') }}</span>
      </v-tooltip>

    </v-toolbar>
    <v-data-table
      dark
      :mobile-breakpoint="breakpoint"
      :page="page"
      :pageCount="numberOfPages"
      :headers="headers"
      :items="tableData"
      :options.sync="options"
      :server-items-length="totalRows"
      :footer-props="{
        itemsPerPageOptions: itemsPerPageOptions,
        'items-per-page-text': '',
        'page-text': fromItem + '-' + toItem + ' ' + $t('general.of') + ' ' + totalRows
      }"
      :dense="true"
      :loading-text="$t('loading_data')"
      class="elevation-1 secondary white--text"
      sort-by="name"
      :loading="tableDataLoading"
      height="80vh"
    >
      <template v-slot:item.total="{ item }">
        <div class="text-right">
          {{ formatCurrency(item.total) }}
        </div>
      </template>
      <template v-slot:item.date_from="{ item }">
        {{ formatDate(item.date_from) }}
      </template>
      <template v-slot:item.date_to="{ item }">
        {{ formatDate(item.date_to) }}
      </template>
      <!----------------------------------- ## FILTERS ## ------------------------------------>
      <template v-slot:body.prepend>
        <tr style="height: 60px !important;">
          <th
            v-for="header in headers"
            :key="header.name"
            class="py-0 px-2 my-0 secondary white--text">
            <v-text-field
              v-model="filters[header.value]"
              @keyup.enter.native="refreshData"
              :placeholder="'Filter ' + header.text"
              filled
              dense
              height="10px"
              hide-details
              style="font-size: inherit;"
              class="secondary ma-0 pa-0"
              v-eager
              enterkeyhint="done"
            />
          </th>
        </tr>
      </template>
      <!----------------------------------- ## TOTALS ## ------------------------------------>
      <template v-slot:body.append>
        <tr v-if="tableData && tableData.length > 0">
          <th
            v-for="header in headers"
            :key="header.name"
            class="py-0 pr-1 my-0 white--text tertiary text-right">
            {{ header.name === 'total' ? sumTotal : (header.name === 'help_type' ? $t('general.total') : '') }}
          </th>
        </tr>
      </template>
      <!-------------------------------- ## NO DATA ## ----------------------------------->
      <template v-slot:no-data>
        <div class="text-xs-center">
          <v-alert color="error" icon="mdi-alert-circle-outline">
            {{ errorMessage }}
          </v-alert>
        </div>
      </template>
    </v-data-table>
    <!---------------------------------- Add item Dialog  ----------------------------------------->
  </v-container>
</template>

<script>
import {
  formatCurrency,
  formatDate,
  readTableDataPostPagination
} from "../../../statics/DataTableFunctions";


export default {
  name: "HelpRegistriesCovidPublic",
  data() {
    return {
      apiRead: '/api/help_registries/covid/public',
      breakpoint: 0,
      page: 1,
      numberOfPages: 10,
      totalRows: 0,
      itemsPerPage: 10,
      itemsPerPageOptions: [
        10,
        20,
        30,
        50,
        100,
        200,
        500
      ],
      options: {
        sortBy: [
          'date_from'
        ],
        sortDesc: [
          true
        ]
      },
      translation: 'help_registries.covid',
      reportData:{
        folder: 'helpRegistries/covid',
        name: 'helpRegistryCovid',
        type: '.pdf'
      },
      reportDownloading: false,
      tableDataLoading: false,
      isRefreshingData: false,
      tableData: [],
      filteredTableData: [],
      filters: {
        is_active: '',
      },
      errorMessage: this.$t('no_data'),
    }
  },
  methods: {
    readTableDataPostPagination,
    formatCurrency,
    formatDate,
    refreshData(resetPagination = false, resetFilters = false, reportData = null) {
      if (resetPagination) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
        this.isRefreshingData = true;
      }
      if (resetFilters) {
        Object.keys(this.filters).forEach(f => {
          this.filters[f] = ''
        });
      }
      this.readTableDataPostPagination(
        this.apiRead,
        null,
        null, {
          filters: this.filters,
          options: this.options,
          report_data: reportData,
        },
        !!reportData
      );
    },
  },
  computed: {
    fromItem() {
      return this.options.page === 1 ? 1 : (this.options.page - 1) * this.options.itemsPerPage + 1
    },
    toItem() {
      if (this.options.itemsPerPage > this.totalRows) {
        return this.totalRows;
      }
      if (this.options.page === 1) {
        return this.options.itemsPerPage
      }

      const toItems = this.options.page * this.options.itemsPerPage;

      if (toItems > this.totalRows) {
        return this.totalRows;
      }

      return toItems;
    },
    sumTotal() {
      let sum = 0;
      this.tableData.forEach(item => {
        sum += parseFloat(item.total);
      })
      return formatCurrency(sum);
    },
    headers() {
      return [
        {
          text: this.$t(this.translation + '.help_provider'),
          name: 'cb_help_providers.name',
          align: 'left',
          sortable: true,
          value: 'cb_help_providers.name',
          width: '8%'
        },
        {
          text: this.$t(this.translation + '.help_receiver.name'),
          name: 'help_receiver_name',
          align: 'left',
          sortable: true,
          value: 'cb_help_receivers.name',
          width: '15%'
        },
        {
          text: this.$t(this.translation + '.help_receiver.pib'),
          name: 'help_receiver_pib',
          align: 'left',
          sortable: true,
          value: 'cb_help_receivers.pin',
          width: '2%'
        },
        {
          text: this.$t(this.translation + '.help_measure'),
          name: 'help_measure',
          align: 'left',
          sortable: true,
          value: 'cb_help_measures.name',
          width: '15%'
        },
        {
          text: this.$t(this.translation + '.agency_decision'),
          name: 'agency_decision',
          align: 'left',
          sortable: true,
          value: 'cb_agency_decisions.number',
          width: '8%'
        },
        {
          text: this.$t(this.translation + '.provider_decision'),
          name: 'provider_decision',
          align: 'left',
          sortable: true,
          value: 'cb_provider_decisions.number',
          width: '8%'
        },
        {
          text: this.$t(this.translation + '.help_user_type'),
          name: 'help_user_type',
          align: 'left',
          sortable: true,
          value: 'cb_help_user_types.name',
          width: '10%'
        },
        {
          text: this.$t(this.translation + '.activity'),
          name: 'activity',
          align: 'left',
          sortable: true,
          value: 'cb_activities.name',
          width: '12%'
        },
        {
          text: this.$t(this.translation + '.help_type'),
          name: 'help_type',
          align: 'left',
          sortable: true,
          value: 'cb_help_types.name',
          width: '10%'
        },
        {
          text: this.$t(this.translation + '.total'),
          name: 'total',
          align: 'left',
          sortable: true,
          value: 'total',
          width: '6%'
        },
        {
          text: this.$t(this.translation + '.date_from'),
          name: 'date_from',
          align: 'left',
          sortable: true,
          value: 'date_from',
          width: '3%'
        },
        {
          text: this.$t(this.translation + '.date_to'),
          name: 'date_to',
          align: 'left',
          sortable: true,
          value: 'date_to',
          width: '3%'
        }
      ];
    }
  },
  watch: {
    options: {
      handler() {
        if (!this.isRefreshingData) {
          this.refreshData()
        }
      },
      deep: true
    }
  }
}
</script>

<style>

</style>

